import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { FaFilePdf } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { IMeeting } from '../../../../../types';
import { IconWrapper } from '../../../../IconWrapper/IconWrapper';

interface IDocumentsProps {
  meeting: IMeeting;
}

const Documents = ({ meeting }: IDocumentsProps) => {
  const getDocument = (document: string) => () => {
    axios
      .get(`/api/meeting/${meeting._id}/document/${document}`, {
        responseType: 'blob',
      })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        if (pdfWindow !== null) pdfWindow.location.href = fileURL;
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  return (
    <Card>
      <Card.Header>Documents</Card.Header>
      <Card.Body className="d-flex flex-column gap-2">
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="secondary" onClick={getDocument('invite')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Invite</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="secondary" onClick={getDocument('response')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Response</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button
              variant="secondary"
              onClick={getDocument('letters/blank')}
              className="w-100"
            >
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Blank invitation letters</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button
              variant="secondary"
              onClick={getDocument('letters/officials')}
              className="w-100"
            >
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Invitation letters to officials</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="secondary" onClick={getDocument('letters/others')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Invitation letters</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="secondary" onClick={getDocument('sign')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Attendance sheet</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="secondary" onClick={getDocument('candidates')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                  <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>List of candidates</Col>
              </Row>
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Documents;
